<div class="autocomplete">
  <div class="autocomplete-main">
    <ul>
      <li *ngFor="let email of showEmails">
        <div><span>{{email.name}}</span><strong class="close" (click)="onRemove(email)">X</strong></div>
      </li>
    </ul>
    <div class="autocomplete-area">
      <textarea [disabled]="disabled" rows="1" [placeholder]=" disabled ? '' : placeholder" [(ngModel)]="input" (ngModelChange)="onInputChange($event)" (keydown.backspace)="onBackspace($event)" (keydown.enter)="onEnter($event)"></textarea>
    </div>
  </div>
</div>
<div class="autocomplete-results">
    <app-helpers-forms-select-users-autocomplete [term]="input" (select)="selectUser($event)"></app-helpers-forms-select-users-autocomplete>
</div>
